import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("h1", {
    class: _normalizeClass({
      'text-3xl text-4xl@md text-6xl@lg': _ctx.size === 'md',
      'text-4xl text-9xl@lg': _ctx.size === 'lg',
    })
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}